import { HOCS_STATE_KEY } from "~/hocs";
import { GRID_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[HOCS_STATE_KEY][GRID_DATA_KEY];

export const getDropdowns = (state): Record<string, any[]> => _getModuleState(state).dropdowns;
export const getGridData = (state) => _getModuleState(state);
export const getOrgLevelData = (state) => _getModuleState(state).orgLevelData;
export const getUserPreference = (state) => _getModuleState(state).userPreference;
